export const platformAccess = {
  junior: {
    required: [
      { platform: 'GitHub', access: 'Developer', purpose: 'Code repository access', setup: 'Request team repo access from admin' },
      { platform: 'Jira', access: 'Developer', purpose: 'Task tracking', setup: 'Account created by admin' },
      { platform: 'Slack', access: 'Member', purpose: 'Team communication', setup: 'Join #backend-team channel' },
      { platform: 'AWS Console', access: 'ReadOnly', purpose: 'Infrastructure monitoring', setup: 'Request IAM user from DevOps' }
    ],
    optional: [
      { platform: 'Postman Team', access: 'Collaborator', purpose: 'Shared API collections', setup: 'Join team workspace' },
      { platform: 'MongoDB Atlas', access: 'Developer', purpose: 'Database management', setup: 'Request project access' }
    ]
  },
  mid: {
    required: [
      { platform: 'AWS Console', access: 'Developer', purpose: 'Deploy and manage services', setup: 'Request elevated IAM permissions' },
      { platform: 'Datadog', access: 'Standard', purpose: 'Monitoring and alerting', setup: 'Account provisioned by admin' },
      { platform: 'PagerDuty', access: 'Responder', purpose: 'On-call rotation', setup: 'Added to escalation policy' },
      { platform: 'Confluence', access: 'Editor', purpose: 'Technical documentation', setup: 'Join backend space' }
    ],
    optional: [
      { platform: 'New Relic', access: 'Developer', purpose: 'Application monitoring', setup: 'Request team access' },
      { platform: 'Sentry', access: 'Member', purpose: 'Error tracking', setup: 'Join backend project' }
    ]
  },
  senior: {
    required: [
      { platform: 'AWS Console', access: 'Admin', purpose: 'Full infrastructure management', setup: 'Request admin IAM role' },
      { platform: 'Terraform Cloud', access: 'Admin', purpose: 'Infrastructure as code', setup: 'Team admin permissions' },
      { platform: 'PagerDuty', access: 'Admin', purpose: 'Incident management', setup: 'Admin role for team' },
      { platform: 'GitHub', access: 'Admin', purpose: 'Repository management', setup: 'Admin access to org repos' }
    ],
    optional: [
      { platform: 'Splunk', access: 'Power User', purpose: 'Advanced log analysis', setup: 'Request elevated permissions' },
      { platform: 'Vault', access: 'Admin', purpose: 'Secret management', setup: 'Admin policy assignment' }
    ]
  }
};
